import React from 'react'
import Modal from '../../components/Modals/Modal'

const UsernameModal = ({modalOpen, setModalOpen}) => {
  return (
    <Modal
        isOpen={modalOpen}
        onClose={()=>setModalOpen(false)}
        title="Enter a new username"
    >
        <form action="">
            <div className="flex flex-col gap-2">
                <input type="text" className='border border-gray-500 bg-gray-100 rounded px-2 py-1 outline-none' />
                <button className="bg-green-600 hover:bg-green-700 text-white rounded py-1">Change Username</button>
            </div>
        </form>
    </Modal>
  )
}

export default UsernameModal